<template>
  <v-menu
    offset-y
    left
    :close-on-content-click="true"
    content-class="accruals-estimates-overflow-menu"
  >
    <template #activator="{ on, attrs }">
      <base-button
        icon-style
        small
        class="shadow-off accruals-estimates-page__overflow-btn"
        :class="{
          'rotate-90': rotateIcon,
          'accruals-estimates-page__overflow-btn--compact': compact,
        }"
        :image="assets.ESTIMATES_OVERFLOW_DOTS"
        image-alt=""
        :aria-label="ariaLabel"
        :data-testid="activatorTestid"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <div class="accruals-estimates-overflow-menu__panel" :data-testid="menuTestid">
      <template v-for="(item, index) in resolvedItems">
        <div
          v-if="item.id === 'divider'"
          :key="`divider-${index}`"
          class="accruals-estimates-overflow-menu__divider"
          aria-hidden="true"
        />
        <button
          v-else
          :key="item.id"
          type="button"
          class="accruals-estimates-overflow-menu__item"
          :class="{ 'accruals-estimates-overflow-menu__item--emphasis': item.emphasis }"
          :data-testid="`${menuTestid}__item--${item.id}`"
          @click="onSelect(item)"
        >
          <span class="accruals-estimates-overflow-menu__icon-wrap">
            <img
              v-if="item.icon"
              :src="item.icon"
              alt=""
              class="accruals-estimates-overflow-menu__icon"
            />
          </span>
          <span class="accruals-estimates-overflow-menu__label">{{ item.label }}</span>
          <span
            v-if="item.external"
            class="accruals-estimates-overflow-menu__external"
            aria-hidden="true"
          >
            <img
              :src="assets.ESTIMATES_EXTERNAL_LINK"
              alt=""
              class="accruals-estimates-overflow-menu__external-icon"
            />
          </span>
        </button>
      </template>
    </div>
  </v-menu>
</template>

<script>
import { ACCRUALS_ASSETS } from '../accrualsPageConstants';

export default {
  name: 'AccrualsEstimatesOverflowMenu',
  props: {
    items: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: 'More actions' },
    activatorTestid: { type: String, default: 'accruals-estimates-overflow-menu' },
    menuTestid: { type: String, default: 'accruals-estimates-overflow-menu' },
    rotateIcon: { type: Boolean, default: true },
    compact: { type: Boolean, default: false },
  },
  data() {
    return {
      assets: ACCRUALS_ASSETS,
    };
  },
  computed: {
    resolvedItems() {
      return (this.items || []).map((item) => {
        if (item.id === 'divider') return item;
        return {
          ...item,
          icon: item.icon || ACCRUALS_ASSETS[item.iconKey] || '',
        };
      });
    },
  },
  methods: {
    onSelect(item) {
      this.$emit('select', item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimatesOverflowButton.scss';
</style>

<style lang="scss">
@import './AccrualsEstimatesOverflowMenu.scss';
</style>
